import { supabase } from './supabase';

export async function submitFeedback({
  userId,
  confusedText,
  usefulText,
  valuableFeatureText,
  breakageText,
  payText,
}) {
  const payload = {
    user_id: userId,
    confused_text: confusedText?.trim() || '',
    useful_text: usefulText?.trim() || '',
    valuable_feature_text: valuableFeatureText?.trim() || '',
    breakage_text: breakageText?.trim() || '',
    pay_text: payText?.trim() || '',
  };

  const { data, error } = await supabase
    .from('feedback_submissions')
    .insert(payload)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function fetchAllFeedbackSubmissions() {
  const { data, error } = await supabase
    .from('feedback_submissions')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
}